import React from "react";

export function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 15.625C0 15.2799 0.279822 15 0.625 15H15.625C15.9702 15 16.25 15.2799 16.25 15.625C16.25 15.9702 15.9702 16.25 15.625 16.25H0.625C0.279822 16.25 0 15.9702 0 15.625Z"
        fill="#A4A3B1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.2336 5.19173C15.4777 4.94765 15.4777 4.55193 15.2336 4.30785L11.1088 0.183058C10.8647 -0.0610193 10.469 -0.0610195 10.2249 0.183058L3.19574 7.21225C2.92225 7.48574 2.76861 7.85667 2.76861 8.24345L2.76861 12.0231C2.76861 12.3682 3.04843 12.6481 3.39361 12.6481L7.17322 12.6481C7.55999 12.6481 7.93093 12.4944 8.20442 12.2209L15.2336 5.19173ZM13.9078 4.74979L12.4346 6.22293L9.19374 2.98202L10.6669 1.50888L13.9078 4.74979ZM8.30985 3.86591L11.5508 7.10681L7.32053 11.337C7.28146 11.3761 7.22847 11.3981 7.17322 11.3981L4.01861 11.3981L4.01861 8.24345C4.01861 8.18819 4.04056 8.1352 4.07963 8.09613L8.30985 3.86591Z"
        fill="#A4A3B1"
      />
    </svg>
  );
}
